import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CheckinPassengerInputResultEffect } from './checkin-passenger-input-result.effect';
import { checkinPassengerInputResultReducer } from './checkin-passenger-input-result.reducer';
import {
  CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME,
  CheckinPassengerInputResultState,
} from './checkin-passenger-input-result.state';

/** Token of the CheckinPassengerInputResult reducer */
export const CHECKIN_PASSENGER_INPUT_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<CheckinPassengerInputResultState, Action>
>('Feature CheckinPassengerInputResult Reducer');

/** Provide default reducer for CheckinPassengerInputResult store */
export function getDefaultCheckinPassengerInputResultReducer() {
  return checkinPassengerInputResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME, CHECKIN_PASSENGER_INPUT_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([CheckinPassengerInputResultEffect]),
  ],
  providers: [
    { provide: CHECKIN_PASSENGER_INPUT_RESULT_REDUCER_TOKEN, useFactory: getDefaultCheckinPassengerInputResultReducer },
  ],
})
export class CheckinPassengerInputResultStoreModule {
  public static forRoot<T extends CheckinPassengerInputResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinPassengerInputResultStoreModule> {
    return {
      ngModule: CheckinPassengerInputResultStoreModule,
      providers: [{ provide: CHECKIN_PASSENGER_INPUT_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
